import { Box, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";

function Details() {
  const { member } = useSelector((state) => state.authSlice);

  return (
    <Box
      sx={{
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>
            <Typography
              fontSize={20}
              fontWeight="600"
              color="other.color1"
              mb={1}
            >
              Personal Information
            </Typography>
            <Field label="Full Name" value={member?.fullName || "User Name"} />
            <Field label="Username" value={member?.username || "username"} />
            <Field label="Email" value={member?.email || "User Email"} />
            <Field label="Phone Number" value={member?.phone || "N/A"} />
            <Field label="Role" value={member?.userRole || "User Role"} />
            <Field label="Blood Group" value={member?.bloodGroup || "N/A"} />
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>
            <Typography
              fontSize={20}
              fontWeight="600"
              color="other.color1"
              mb={1}
            >
              Address Information
            </Typography>
            <Field label="Street" value={member?.address?.street || "N/A"} />
            <Field label="City" value={member?.address?.city || "N/A"} />
            <Field label="State" value={member?.address?.state || "N/A"} />
            <Field label="Country" value={member?.address?.country || "N/A"} />
            <Field label="Zip Code" value={member?.address?.zip || "N/A"} />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

function Field({ label, value }) {
  return (
    <Box>
      <Typography fontSize={18} fontWeight="500" color="dark.light">
        {label}
      </Typography>
      <Box
        sx={{
          p: 1,
          borderRadius: 1,
          fontWeight: "500",
          color: "dark.light",
          border: "1px solid",
          textTransform: "capitalize",
          borderColor: "other.color2",
        }}
      >
        {value}
      </Box>
    </Box>
  );
}

export default Details;
